module.exports = __webpack_public_path__ + "img/imd-ch-pix.3a02f387.jpg";